module.exports = __webpack_public_path__ + "img/13.4342220a.jpeg";